import { Component } from '@angular/core';

@Component({
  templateUrl: 'learn-about-tidy.html'
})
export class LearnAboutTidyPage {}
